import React from 'react';
import {
  IonContent, IonPage, IonHeader,
} from '@ionic/react';
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import GeneralTextCardAtom from '../atoms/generalTextCardAtom/GeneralTextCardAtom';
import BackrsButton from '../atoms/backrsButton/BackrsButton';
import appColors from '../app_colors';
import MainImage from '../../pages/wholeme/molecules/mainImage/MainImage';

const ctaStyle = {
  width: '100%',
  height: '57px',
  fontSize: '20px',
  fontWeight: 700,
  borderRadius: '40px',
  color: '#063D8F',
  backgroundColor: '#FFFFFF',
  border: 'none',
  '&:hover': {
    backgroundColor: '#FFFFFF',
  },
};

const fixedButtonContOverride = {
  px: '24px',
  position: 'fixed',
  bottom: '1px',
  width: '90%',
  backgroundColor: appColors.splashBackground,
  height: '110px',
};

const GenericSplashPage = ({
  ctaOverrideStyles = {},
  ctaLabel,
  ctaHandler,
  title,
  body,
  heroImage = null,
  backgroundImage = '',
  heroImageOverrideStyles,
  children,
  hideCta,
}) => (
  <IonPage>
    <IonHeader className="ion-no-border" />
    <IonContent
      fullscreen
      style={{
        fontSize: '12px',
        '--background': `url(${backgroundImage}), ${appColors.splashBackground}`,
        '--background-position': 'center',
        '--background-size': 'cover',
        '--background-repeat': 'no-repeat',
      }}
    >
      <Stack
        sx={{
          pt: 10,
          mb: 8,
          mt: 2,
          alignItems: 'center',
        }}
      >
        <Stack
          sx={{
            px: '24px',
            mb: '45px',
          }}
        >
          <GeneralTextCardAtom
            title={title}
            body={body}
            titleStyles={{
              textAlign: 'center',
              color: '#FFFFFF',
              fontSize: '28px',
              fontWeight: 700,
              paddingBottom: '2rem',
            }}
            bodyStyles={{
              fontSize: '20px',
              fontWeight: 400,
              textAlign: 'center',
              color: '#FFFFFF',
              opacity: 1,
            }}
          />
        </Stack>
        <Stack
          spacing={2.5}
          sx={{
            mb: '1px', textAlign: 'center', width: '20rem', height: '20rem', mt: '3rem',
          }}
        >
          {heroImage && (
            <MainImage imageSrc={heroImage.src} imageAlt={heroImage.alt} imageStylesOverride={heroImageOverrideStyles} />
          )}
          {children && children}
        </Stack>
      </Stack>
      {!hideCta && (
        <Stack
          sx={fixedButtonContOverride}
        >
          <BackrsButton
            label={ctaLabel}
            onClick={ctaHandler}
            buttonStylesOverride={{ ...ctaStyle, ...ctaOverrideStyles }}
          />
        </Stack>
      )}
    </IonContent>
  </IonPage>
);

GenericSplashPage.propTypes = {
  ctaOverrideStyles: PropTypes.objectOf(PropTypes.string),
  ctaLabel: PropTypes.string.isRequired,
  ctaHandler: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  heroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
};


export default GenericSplashPage;
